import { buttonVariants } from '@/components/ui/button';
import { cn } from '@liquidbudget/common';
import { Link, useLocation } from 'react-router-dom';

type BudgetNavLinkProps = {
  to: string;
  text: string;
  icon: React.ReactNode;
  aside?: string;
  matchFn?: (pathname: string, to: string) => boolean;
};

export function BudgetNavLink({ to, text, icon, aside, matchFn }: BudgetNavLinkProps) {
  const { pathname } = useLocation();
  const normalizedPathname = normalizePath(pathname);
  const normalizedTo = normalizePath(to);
  const isActive = matchFn ? matchFn(normalizedPathname, normalizedTo) : normalizedPathname === normalizedTo;

  return (
    <Link to={to} className={cn(buttonVariants({ variant: isActive ? 'default' : 'ghost', size: 'default' }))}>
      {icon}
      {text}
      <span className="ml-auto text-xs">{aside && aside}</span>
    </Link>
  );
}

function normalizePath(path: string): string {
  return path.split('?')[0].replace(/\/+$/, '').toLowerCase();
}
